<div class="card-container">
  <div class="header">
    <h4 class="title">Buy As Gift</h4>
  </div>
  <div class="context" *ngIf="paymentData">
    <div class="image-co">
      <img [src]="paymentData.product.logo" alt="" />
    </div>
    <div class="desc-co">
      <p class="desc-title">{{ paymentData.product.name }}</p>
      <p class="desc-subtitle">
        {{ paymentData.order.payablePrice }} {{ paymentData.currency.symbol }}
      </p>
    </div>
  </div>
  <div class="form-co">
    <form class="input-container" [formGroup]="giftForm">
      <input placeholder="Enter Email" formControlName="email" />
      <div class="divider"></div>
      <input placeholder="Name" formControlName="name" />
      <input placeholder="Your Note(Optional)" formControlName="note" />
    </form>
    <button
      mat-button
      class="custom-full-button"
      [disabled]="
        !paymentData.isValid ||
        paymentData.order.basePrice === null ||
        giftForm.invalid
      "
      (click)="submitGift()"
    >
      Buy Now
    </button>
  </div>
</div>
